import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Observer, Subject } from 'rxjs';

// Local Models
import { ServicePathsSettings } from "../configuration/service-paths-settings";

@Injectable({
  providedIn: 'root'
})
export class PraticheMappingService {

  tipiPratica: any;
  private subject = new Subject<any>();

  public notifyPraticheSubject: Subject<any> = new Subject<any>();
  public notifyPraticheObservable: Observable<any> = this.notifyPraticheSubject.asObservable();

  constructor(
    private http: HttpClient
  ) { }

  getListTipiPraticaSubject(): Observable<any> {
    return this.subject.asObservable();
  }

  getAllTipiPratica(): Observable<any> {
    if (this.tipiPratica)
      return Observable.create((observer: Observer<any>) => observer.next(this.tipiPratica));
    return Observable.create((observer: Observer<any>) => {
      const url = ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_TIPI_PRATICA;
      // const url = ServicePathsSettings.DOMINIO_API_GATEWAY + ServicePathsSettings.URL_TIPI_PRATICA_API_GATEWAY;
      this.http.get(url).subscribe(res => {
        this.tipiPratica = res;
        observer.next(res);
        this.subject.next(res);
        this.notifyPraticheSubject.next(res);
      });
    });
  }

}
